import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AppContext from '../../../Context/AppContext';
import requestAxios from '../../../util/requestAxios';
import UserMenu from '../../DashboardV2/UserMenu/UserMenu';
import './GlobalUserMenu.css';

const LOGIN_PATHS = new Set(['/', '/login', '/login-v2', '/home']);

const BUILT_IN_USER_MENU = [
    /^\/dashboard-v2(\/|\?|$)/i,
    /^\/dashboard(\/|\?|$)/i,
    /^\/DashboardCoach(\/|\?|$)/i,
    /^\/NonSubscriber(\/|\?|$)/i,
    /^\/steps(\/|\?|$)/i,
    /^\/customizeQuestions(\/|\?|$)/i,
];

function shouldShowGlobalUserMenu(pathname, token) {
    if (!token) return false;
    if (LOGIN_PATHS.has(pathname)) return false;
    return !BUILT_IN_USER_MENU.some((pattern) => pattern.test(pathname));
}

const GlobalUserMenu = () => {
    const { checkUserSession } = useContext(AppContext);
    const history = useHistory();
    const location = useLocation();
    const session = checkUserSession() || {};
    const { token, userId } = session;

    const [profile, setProfile] = useState(null);
    const [avatarBust, setAvatarBust] = useState(0);

    const visible = useMemo(
        () => shouldShowGlobalUserMenu(location.pathname, token),
        [location.pathname, token]
    );

    useEffect(() => {
        if (!visible || !token || !userId) return undefined;

        let cancelled = false;

        (async () => {
            const { error, data } = await requestAxios({
                url: `Customer/GetCustomerProfileInfo/${userId}`,
                token,
            });
            if (!cancelled && !error && data) {
                setProfile(data);
                setAvatarBust(Date.now());
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [visible, token, userId]);

    if (!visible) return null;

    return (
        <div className="global-user-menu" aria-label="Account menu">
            <UserMenu
                profile={profile}
                avatarBust={avatarBust}
                onOpenProfile={() => history.push('/dashboard-v2?profile=1')}
            />
        </div>
    );
};

export default GlobalUserMenu;
